import { StyleSheet } from '@react-pdf/renderer'

export const balanceCellStyles = StyleSheet.create({
  cellContainer: {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '20px',
  },
  text: {
    fontSize: '10px',
    textAlign: 'right',
    width: '100%',
  },
  textBold: {
    fontWeight: 'bold',
  },
})
